import { n_pricing } from '../../../modules/i18n/strings/auto/wording'

export const enum PRICING_TAB {
  FLEXIBLE = 'b2c',
  B2B = 'b2b2c',
  PROMOTION = 'promotion',
  EVERY_WEEK = 'every_week',
}

export const enum PRICING_PROPERTY {
  EVERY_WEEK_PRODUCT = 'only_every_week_products',
  FLEXIBLE_PRODUCT = 'only_flexible_products',
}

// Filter B2C product lines based on credit type and duration
export const getProductLines = (creditList, creditType, duration) => {
  if (!creditList || !Array.isArray(creditList)) return []

  const filteredList = creditList.filter((list) =>
    creditType === PRICING_PROPERTY.EVERY_WEEK_PRODUCT ? list.is_weekly_lesson_package : !list.is_weekly_lesson_package
  )

  return filteredList.filter((line) => line.duration === duration)
}

// Get B2C product groups based on active tab
export const getProductsGroup = (activeId, productArrayList, duration) => {
  if (!productArrayList || !productArrayList.product_lines) return []

  const creditList = productArrayList.product_lines
  let creditType

  switch (activeId) {
    case PRICING_TAB.EVERY_WEEK:
      creditType = PRICING_PROPERTY.EVERY_WEEK_PRODUCT
      break
    case PRICING_TAB.FLEXIBLE:
      creditType = PRICING_PROPERTY.FLEXIBLE_PRODUCT
      break
    default:
      return []
  }

  return getProductLines(creditList, creditType, duration.number)
}

// Filter product lines for a B2B2C company based on duration
export const getProductLineCompany = (productLineCompany, duration) => {
  const creditList = productLineCompany?.product_lines.filter((line) => line.duration == duration.number) || []
  return creditList
}

export const tabs = (t) => [
  {
    id: PRICING_TAB.EVERY_WEEK,
    title: t(n_pricing.every_week.title),
    description: t(n_pricing.every_week.subtitle),
  },
  {
    id: PRICING_TAB.FLEXIBLE,
    title: t(n_pricing.none.title),
    description: t(n_pricing.none.subtitle),
  },
  {
    id: PRICING_TAB.B2B,
    title: t(n_pricing.b2b_price.title),
  },
]
